import { configureStore } from '@reduxjs/toolkit';
import bookingsReducer from './reducers/bookings';
export const accountPageStore = {
    reducer: {
        bookings: bookingsReducer,
    },
};
const store = configureStore(accountPageStore);
export default store;
